import { DateHelper } from "@bryntum/schedulerpro";
import { SwivuFile } from "@/react/components/entityViews/files/types/swivuFile";
import { getFormattedFileSize, getAging } from "@/other/utils/utils";

export type MetadataRow = {
  label: string;
  value: string;
};

/**
 * Formats file metadata into display rows
 */
export const formatFileMetadata = (file: SwivuFile | null): MetadataRow[] => {
  if (!file) return [];

  const uploadedDate = file.createdAt ? DateHelper.format(new Date(file.createdAt), "MM/DD/YYYY") : "";
  const lastUpdatedDate = file.updatedAt ? DateHelper.format(new Date(file.updatedAt), "MM/DD/YYYY") : "";

  const sourceLabel = file.source === "companycam" ? "CompanyCam" : "Swivu";
  const sizeLabel = file.sizeBytes ? getFormattedFileSize(file.sizeBytes) : "";
  const age = file.createdAt ? getAging(file.createdAt) : "";

  return [
    { label: "Source", value: sourceLabel },
    { label: "File size", value: sizeLabel || "" },
    { label: "Uploaded", value: uploadedDate || "" },
    { label: "Last updated", value: lastUpdatedDate || "" },
    { label: "Age", value: String(age || "") }
  ].filter((item) => Boolean(item.value));
};
